import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { merchantDetails } from "../../../types/merchantDetails";

const initialState: merchantDetails = {
  merchnat_id: "",
  merchnat_name: "",
  bg_color: null,
  merchant_logo: null,
  template_id: 1,
  merchant_email: "",
  merchant_mobile: "",
  vpa_collection: false,
};

const MerchantDetails = createSlice({
  name: "merchantDetails",
  initialState,
  reducers: {
    addDetails: (state, action: PayloadAction<Partial<merchantDetails>>) => {
      Object.assign(state, action.payload);
    },
  },
});

export const { addDetails } = MerchantDetails.actions;
export default MerchantDetails.reducer;
